import { render } from "./ResizeBar.vue?vue&type=template&id=5b62b033&scoped=true"
import script from "./ResizeBar.vue?vue&type=script&lang=js"
export * from "./ResizeBar.vue?vue&type=script&lang=js"

import "./ResizeBar.vue?vue&type=style&index=0&id=5b62b033&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b62b033"]])

export default __exports__